import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createUnit",
    serviceName: "auth",
    query: gql`
      mutation createDoctor(
        $id: String
        $lat: String
        $lng: String
        $city: String
        $state: String
        $email: String
        $address: String
        $site_url: String
        $tellphone: String
        $postal_code: String
        $register_date: String
        $registered_number: String
        $national_identifier: String
        $specialist: String # generalDentist, restorativeDentistry, prosthodontics, orthodontics
        $medical_number: String
        $details: String
      ) {
        createDoctor(
          id: $id
          lat: $lat
          lng: $lng
          city: $city
          state: $state
          email: $email
          address: $address
          site_url: $site_url
          tellphone: $tellphone
          postal_code: $postal_code
          register_date: $register_date
          registered_number: $registered_number
          national_identifier: $national_identifier
          specialist: $specialist
          medical_number: $medical_number
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
